import * as React from "react";
import { Icon } from "office-ui-fabric-react/lib/Icon";
import styled from "styled-components";
import { RouteComponentProps } from "react-router";
import * as G from "~/components/global.style";

export interface Props extends RouteComponentProps<any>
{
    
}

interface State
{
    
}

const IconWrapper = styled.div<{ active?: boolean }>`
    margin-top: 30px;
    font-size: 40px;
    color: ${props => props.active ? G.PrimaryColor : "#d5e2e9" };
    &:hover { 
        cursor: pointer; 
        color: ${ G.PrimaryColor};
    }
    svg path{
        fill: ${props => props.active ?  G.PrimaryColor : "#d5e2e9" };        
    }
    &.active{
        color: ${G.PrimaryColor};
        svg path{
            fill: ${G.PrimaryColor};        
        }    
    }
`;

class Menu extends React.Component<Props, State>
{
    onProductClick = () => this.props.history.push("/products");

    onMediaClick = () => this.props.history.push("/media");

    // onTranslationsClick = () => this.props.history.push("/translations");

    onCollectionOverviewClick = () => this.props.history.push("/collections");

    getLocation = (path: string) =>
    {
        if (location.pathname.indexOf(path) !== -1)
        {
            return true;
        }
        return false;

    }

    logout = () =>
    {
        const isWindowBrowser = (navigator.userAgent.indexOf("MSIE") !== -1) || navigator.userAgent.indexOf("EDGE") !== -1;

        if (isWindowBrowser)
        {
            document.execCommand("ClearAuthenticationCache");
            window.close();
        }
        else
        {
            alert("Close the browser to logout");
        }
    }

    render()
    {
        return (
            <div>
                <IconWrapper className={this.getLocation("products") ? "active" : ""}>
                    <Icon iconName="book" onClick={this.onProductClick}/>
                    {/* <Icon iconName="Dictionary" /> */}
                </IconWrapper>
                <IconWrapper className={this.getLocation("media") ? "active" : ""}>
                    <Icon iconName="image" onClick={this.onMediaClick}  />
                </IconWrapper>
                {/*<IconWrapper className={this.getLocation("translations") ? "active" : ""}>*/}
                {/*    <Icon iconName="bubble" onClick={this.onTranslationsClick} />*/}
                {/*</IconWrapper>*/}
                <IconWrapper className={this.getLocation("collections") ? "active" : ""}>
                    <Icon iconName="tree" onClick={this.onCollectionOverviewClick} />
                </IconWrapper>
                <IconWrapper >
                    <Icon iconName="exit" onClick={this.logout} />
                </IconWrapper>
            </div>
        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/layout/Menu.tsx